var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-994663cd-bf04-408d-9004-b98153052df7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.16 67.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.14,35.95l-29.16,30.11c-1.88,1.94-4.94,1.94-6.83,0L6,35.95C-2.47,27.19-1.97,12.69,7.49,4.62,15.75-2.42,28.05-1.16,35.61,6.67l2.97,3.06,2.97-3.06c7.58-7.82,19.86-9.09,28.12-2.05,9.46,8.08,9.96,22.57,1.48,31.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSelection);
export default __webpack_public_path__ + "static/media/dark - selection.9baf5c12a059893c71fd61b37e914bf1.svg";
export { ForwardRef as ReactComponent };